import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Alert,
  Grid,
  Paper,
  Chip
} from '@mui/material';
import {
  ContentCopy,
  OpenInNew,
  CheckCircle,
  Warning
} from '@mui/icons-material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#9c27b0',
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 500,
    },
  },
});

export default function MUICleanComponent() {
  const [copiedIndex, setCopiedIndex] = useState(null);

  const courses = [
    { 
      level: '100 Level', 
      link: 'https://students.elms.ng/enroll/AJ8yoxoO', 
      color: '#1976d2',
      chipColor: 'primary'
    },
    { 
      level: '200 Level', 
      link: 'https://students.elms.ng/enroll/bvTxJtz3', 
      color: '#388e3c',
      chipColor: 'success'
    },
    { 
      level: '400 Level', 
      link: 'https://students.elms.ng/enroll/Der1O7xj', 
      color: '#7b1fa2',
      chipColor: 'secondary'
    },
  ];

  const handleCopy = async (link, index) => {
    try {
      await navigator.clipboard.writeText(link);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    } catch (err) {
      console.error('Failed to copy');
    }
  };

  const handleOpenLink = (link) => {
    window.open(link, '_blank');
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
        {/* Header */}
        <Paper elevation={1} sx={{ borderRadius: 0, mb: 4 }}>
          <Container maxWidth="lg">
            <Box sx={{ py: 4, textAlign: 'center' }}>
              <Typography variant="h4" color="primary" gutterBottom>
                Student Enrollment Portal
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
                Quick access to course enrollment links for all levels
              </Typography>
            </Box>
          </Container>
        </Paper>

        <Container maxWidth="lg">
          {/* Notice Alert */}
          <Alert 
            severity="warning" 
            icon={<Warning />}
            sx={{ mb: 4, borderRadius: 2 }}
          >
            <Typography variant="body2">
              <strong>Important Update:</strong> students.nutriedu.com.ng is now{' '}
              <strong>students.elms.ng</strong>. All activities moved to the new dashboard.
            </Typography>
          </Alert>

          {/* Course Cards */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            {courses.map((course, index) => (
              <Grid item xs={12} md={6} lg={4} key={course.level}>
                <Card 
                  elevation={2}
                  sx={{ 
                    height: '100%',
                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: 4,
                    },
                  }}
                >
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Typography variant="h6" component="h3" sx={{ flexGrow: 1 }}>
                        {course.level}
                      </Typography>
                      {/* <Chip 
                        label="Active" 
                        color={course.chipColor}
                        size="small"
                      /> */}
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                      <Button
                        variant="contained"
                        fullWidth
                        startIcon={<OpenInNew />}
                        onClick={() => handleOpenLink(course.link)}
                        sx={{ 
                          bgcolor: course.color,
                          py: 1.2,
                          '&:hover': {
                            bgcolor: course.color,
                            filter: 'brightness(0.9)',
                          },
                        }}
                      >
                        Open Enrollment
                      </Button>

                      <Button
                        variant="outlined"
                        fullWidth
                        startIcon={
                          copiedIndex === index ? 
                            <CheckCircle sx={{ color: 'success.main' }} /> : 
                            <ContentCopy />
                        }
                        onClick={() => handleCopy(course.link, index)}
                        sx={{ py: 1.2 }}
                        color={copiedIndex === index ? 'success' : 'primary'}
                      >
                        {copiedIndex === index ? 'Copied!' : 'Copy Link'}
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Footer */}
          {/* <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body2" color="text.secondary">
              Need help? Contact your course administrator
            </Typography>
          </Box> */}
        </Container>
      </Box>
    </ThemeProvider>
  );
}